
import React from 'react';

const PermissionDenied = () => {
    return (
        <section className="PageNotFoundSec">
            <div className="container">
                <div className="row align-items-center justify-content-center py-5">

                    <div className="col-12">
                        <div className="PageNotFoundCnt">
                            <img src={require('../../assets/images/access.png')} alt='permission' width="600px"/>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default PermissionDenied;